<template>
<div class="container-fluid">
	<div class="row">
	    <div class="col-12 without-page-title">
	    	<template v-if="groups.loaded && physicians.loaded">
				<physician-map-and-table				
				   	:physician_data="combinedProviders"
				    :client_metrics="user.client.client_metrics ? user.client.client_metrics : null"
					:default_latitude="user.client.latitude ? user.client.latitude : 0"
					:default_longitude="user.client.longitude ? user.client.longitude : 0"
				    default_sort_field="last_name"
				    default_sort_direction="asc"
				    default_per_page="50"
				    :data_loaded="true"
				/>
			</template>

			<div v-else class="page-with-title fill-app-height">
				<img class="center-me" src="/images/loading-color.svg">
			</div>			
		</div>
	</div>
</div>
</template>

<script>
	import { mapGetters, mapState } from 'vuex'
	import BreadcrumbsManager from '../../helpers/BreadcrumbManager';

	export default {
		mixins: [BreadcrumbsManager],

		data() {
			return {
				//physicians: [],
				//data_loaded: false,
			}
		},

		created() {
		},

		activated() {
			this.setBreadcrumbs([
	            { text: 'Home', to: { name: 'home' } },
	            { text: 'Providers', to: { name: 'physicians.list'} },
	            { text: 'Explore & Analyze', to: { name: 'physicians.map'} },
        	]);
		},

		mounted() {
			//this.fetchPhysicians();

			// this.$root.$on('physician_added', data => {
			// 	this.fetchPhysicians();
			// });			
		},

		methods: {
			checkPhysicians() {
				if (this.physicians && this.physicians.physicians) {

				}
			},

			fetchPhysicians() {
				// axios.get('/api/physicians/list').then(({data}) => {
    //                 //this.physicians = data;
    //                 this.data_loaded = true;
    //             });
			}
		},

		computed: {
			...mapState(['groups', 'physicians', 'user']),

			combinedProviders() {
				if (this.groups.loaded && this.physicians.loaded) {
					return [...this.groups.groups, ...this.physicians.physicians];
				}
			},

			// data_loaded() {
			// 	return this.physicians && this.physicians.physicians ? true : false;
			// }
		},

		watch: {
			// physiciansLoaded() {
			// 	this.data_loaded = this.physiciansLoaded;
			// }
		}
	}
</script>